import { CoordinatesInput } from '@/features/graphql/generated/graphql'
import { LocationEvaluation } from '@/features/pos/components/CustomerProfile/queries'
import { useLazyQuery } from '@apollo/client'
import { useCallback } from 'react'
import invariant from 'tiny-invariant'

type Result = { deliverable: true; zoneName: string } | { deliverable: false }

export const useLocationEvaluation = (): ((coordinates: CoordinatesInput) => Promise<Result>) => {
    const [evaluateLocation] = useLazyQuery(LocationEvaluation, { fetchPolicy: 'network-only' })

    return useCallback(
        async (coordinates: CoordinatesInput) => {
            const { data } = await evaluateLocation({ variables: { coordinates } })

            invariant(data, 'Location evaluation failed')

            return data.locationEvaluation as Result
        },
        [evaluateLocation]
    )
}
